import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

const getDefaultSelectedTrainSet = () => {
  return {
    name: null,
    trainSetCarModels: [],
  };
};
export default {
  state: () => ({
    selectedTrainSet: getDefaultSelectedTrainSet(),
  }),

  mutations: {
    setSelectedTrainSet(state, trainSet) {
      Vue.set(state, "selectedTrainSet", trainSet);
    },
    setDefaultSelectedTrainSet(state) {
      Vue.set(state, "selectedTrainSet", getDefaultSelectedTrainSet());
    },
  },

  actions: {
    //TODO: load, update, create
    createTrainSet: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/train-sets/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadPublishedTrainSets: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-sets/entity/published").then((response) => {
        return response.data;
      });
    },

    loadTrainSetHistory: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/schedule/train-sets/history/search", request, {}).then((response) => {
        return response.data;
      });
    },

    loadTrainSets: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-sets/entity").then((response) => {
        return response.data;
      });
    },

    fetchAllTrainSetsWithSubModels: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-sets/find-all-with-sub-models").then((response) => {
        return response.data;
      });
    },

    loadTrainSet: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-sets/entity/" + request.id).then((response) => {
        context.commit("setSelectedTrainSet", response.data);
        return response.data;
      });
    },

    loadSelectedTrainSetHistory: (context, trainSet) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-sets/history/" + trainSet.id, {}).then((response) => {
        return response.data;
      });
    },

    deleteTrainSet: (context, trainSet) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/train-sets/entity/" + trainSet.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          trainSet.intents = intents;
          trainSet.intentId = response.data.id;
          return trainSet;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftTrainSet: (context, trainSet) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/train-sets/draft/" + trainSet.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishTrainSet: (context, trainSet) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-sets/publish/" + trainSet.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },
    rejectTrainSet: (context, trainSet) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-sets/reject/" + trainSet.intentId).then((response) => {
        helper.recallOrRejectEntity(trainSet, "train_set");
        return response.data;
      });
    },
    sendToApprovalTrainSets: (context, trainSet) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-sets/sendToApproval/" + trainSet.intentId).then((response) => {
        if (trainSet.intents[0].type === "CREATE_TRAIN_SET") {
          trainSet.intents[0].status = "WAITING_APPROVAL";
        } else if (trainSet.intents[0].type === "UPDATE_TRAIN_SET") {
          trainSet.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },
    recallTrainSet: (context, trainSet) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-sets/recall/" + trainSet.intentId).then((response) => {
        helper.recallOrRejectEntity(trainSet, "train_set");
        return response.data;
      });
    },
    cancelTrainSet: (context, trainSet) => {
      return axios.get(context.getters.getMcServiceUrl + "/train-sets/cancel/" + trainSet.intentId).then((response) => {
        return response.data;
      });
    },
  },
  getters: {
    getSelectedTrainSet: (state) => {
      return state.selectedTrainSet;
    },
    getPublishedTrainSets: (state) => {
      return state.trainSets.filter((entity) => {
        return entity.intentId === 0;
      });
    },
  },
};
